var map = {
	"./AppIcon.vue": "2630",
	"./AppImage.vue": "a6d9",
	"./AppLink.vue": "77ba",
	"./AppLoadingIcon.vue": "889f",
	"./AppStackedIcons.vue": "f891",
	"./AppSvg.vue": "24ce",
	"./AppVideo.vue": "b16b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d83";